import { DateTime } from "luxon";
import { DehydratedGovPlanProjectContract } from "../types/project";
import { GOVERNMENT_PLAN_STATUS } from "../types/status";

export class DehydratedGovPlanSecretaryProject {
    id: number;

    name: string;

    status: GOVERNMENT_PLAN_STATUS;

    amount: number;

    deadline: Date;

    createdAt: Date;

    constructor(contract: DehydratedGovPlanProjectContract) {
        this.id = contract.id;
        this.name = contract.name;
        this.status = contract.status;
        this.amount = contract.amount;
        this.deadline = new Date(contract.deadline);
        this.createdAt = new Date(contract.createdAt);
    }

    isCompleted() {
        return [
            GOVERNMENT_PLAN_STATUS.COMPLETED,
            GOVERNMENT_PLAN_STATUS.COMPLETED_LATE,
        ].includes(this.status);
    }

    daysUntilDeadline() {
        const deadline = DateTime.fromJSDate(this.deadline);

        return Math.floor(deadline.diffNow("days").days);
    }

    nearDeadline() {
        const deadline = DateTime.fromJSDate(this.deadline);

        return (
            Math.floor(deadline.diffNow("days").days) <
            Math.floor(this.intervalBetweenCreationAndDeadline() / 2)
        );
    }

    isLate() {
        const deadline = DateTime.fromJSDate(this.deadline);

        return Math.floor(deadline.diffNow("days").days) < 0;
    }

    get variant(): "success" | "warning" | "danger" | "primary" {
        if (this.isCompleted()) return "success";

        if (this.isLate()) return "danger";

        if (this.nearDeadline()) return "warning";

        return "primary";
    }

    intervalBetweenCreationAndDeadline() {
        const createdAt = DateTime.fromJSDate(this.createdAt, {
            zone: "America/Sao_Paulo",
        }).startOf("day");
        const deadline = DateTime.fromJSDate(this.deadline, {
            zone: "America/Sao_Paulo",
        }).startOf("day");

        return deadline.diff(createdAt, "days").days;
    }
}
